(() => {
  if (window.gobyincenseMomentsScrollReady) return;
  window.gobyincenseMomentsScrollReady = true;

  const instances = new WeakMap();

  function rootsIn(scope) {
    const roots = [...scope.querySelectorAll('.gobyincense-moment')];
    if (scope.matches?.('.gobyincense-moment')) roots.unshift(scope);
    return roots;
  }

  function init(root) {
    if (instances.has(root)) return;

    const chapter = root.querySelector('.gobyincense-moment__chapter');
    const titleStage = root.querySelector('.gobyincense-moment__title-stage');
    const titleLines = [...root.querySelectorAll('.gobyincense-moment__heading-line')];
    const stackStage = root.querySelector('.gobyincense-moment__stack-stage');
    const layers = [...root.querySelectorAll('.gobyincense-moment__layer')];
    const media = [...root.querySelectorAll('.gobyincense-moment__media')];
    const images = media.map((item) => item.querySelector('.gobyincense-moment__image'));
    const lastLayer = layers.at(-1);
    if (!chapter || !titleStage || !titleLines.length || !stackStage || !lastLayer) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const geometry = { titleTop: 0, titleRange: 1, mobileTitleTravel: [] };
    let enabled = false;
    let nearby = false;
    let frame = 0;
    let destroyed = false;

    const clamp = (value) => Math.max(0, Math.min(1, value));

    function measure() {
      if (!enabled) return;
      const scrollY = window.scrollY;
      const chapterTop = chapter.getBoundingClientRect().top + scrollY;
      if (window.innerWidth <= 989) {
        const titleCenter = titleStage.offsetHeight / 2;
        geometry.titleTop = chapterTop + titleCenter - window.innerHeight * 0.5;
        geometry.titleRange = Math.max(1, window.innerHeight * 0.25);
      } else {
        geometry.titleTop = chapterTop;
        geometry.titleRange = Math.max(1, chapter.offsetHeight - titleStage.offsetHeight);
      }
      const viewportWidth = document.documentElement.clientWidth;
      geometry.mobileTitleTravel = titleLines
        .filter((line) => line.offsetParent !== null)
        .map((line) => Math.min(
          viewportWidth * 0.65,
          Math.max(viewportWidth * 0.28, line.scrollWidth - viewportWidth + viewportWidth * 0.24),
        ));
      const lastLayerStyle = window.getComputedStyle(lastLayer);
      const stickyTop = Number.parseFloat(lastLayerStyle.top) || 0;
      const lastLayerTail = Number.parseFloat(lastLayerStyle.marginBottom) || 0;
      const stackTail = Math.max(
        0,
        stickyTop - lastLayerTail,
      );
      stackStage.style.setProperty('--gobyincense-moment-stack-tail', `${stackTail}px`);
      schedule(true);
    }

    function update() {
      frame = 0;
      if (!enabled) return;

      const scrollY = window.scrollY;
      const titleProgress = clamp((scrollY - geometry.titleTop) / geometry.titleRange);
      const firstLineOffset = -10 * (1 - titleProgress);
      const secondLineOffset = 24 * (1 - titleProgress);
      const visibleTitleLines = titleLines.filter((line) => line.offsetParent !== null);
      if (window.innerWidth <= 989 && visibleTitleLines.length === 3) {
        visibleTitleLines.forEach((line, index) => {
          const direction = index === 1 ? -1 : 1;
          const travel = geometry.mobileTitleTravel[index] || 0;
          const offset = direction * travel * (0.5 - titleProgress);
          line.style.transform = `translate3d(calc(-50% + ${offset}px), 0, 0)`;
        });
      } else {
        if (visibleTitleLines[0]) visibleTitleLines[0].style.transform = `translate3d(calc(-50% + ${firstLineOffset}vw), 0, 0)`;
        if (visibleTitleLines[1]) visibleTitleLines[1].style.transform = `translate3d(calc(-50% + ${secondLineOffset}vw), 0, 0)`;
      }

      media.forEach((item, index) => {
        const image = images[index];
        if (!image) return;
        const rect = item.getBoundingClientRect();
        const progress = clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height));
        const travel = Math.max(0, image.offsetHeight - item.clientHeight);
        image.style.transform = `translate3d(0, ${-travel * progress}px, 0)`;
      });
    }

    function schedule(force = false) {
      if (enabled && (nearby || force) && !frame) frame = requestAnimationFrame(update);
    }

    function onModeChange() {
      enabled = !reducedMotion.matches;
      root.classList.toggle('gobyincense-moment--enhanced', enabled);
      if (enabled) {
        measure();
      } else {
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        stackStage.style.removeProperty('--gobyincense-moment-stack-tail');
        titleLines.forEach((line) => { line.style.transform = ''; });
        images.forEach((image) => { if (image) image.style.transform = ''; });
      }
    }

    const visibility = new IntersectionObserver(([entry]) => {
      nearby = entry.isIntersecting;
      if (nearby) measure();
      else schedule(true);
    }, { rootMargin: '100% 0px' });
    visibility.observe(root);

    const resize = new ResizeObserver(measure);
    resize.observe(chapter);
    resize.observe(lastLayer);
    const onScroll = () => schedule();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    reducedMotion.addEventListener('change', onModeChange);
    document.fonts?.ready.then(() => { if (!destroyed) measure(); });
    onModeChange();

    instances.set(root, () => {
      destroyed = true;
      visibility.disconnect();
      resize.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', measure);
      window.removeEventListener('load', measure);
      reducedMotion.removeEventListener('change', onModeChange);
      stackStage.style.removeProperty('--gobyincense-moment-stack-tail');
      images.forEach((image) => { if (image) image.style.transform = ''; });
      if (frame) cancelAnimationFrame(frame);
    });
  }

  document.querySelectorAll('.gobyincense-moment').forEach(init);
  document.addEventListener('shopify:section:load', (event) => rootsIn(event.target).forEach(init));
  document.addEventListener('shopify:section:unload', (event) => {
    rootsIn(event.target).forEach((root) => {
      instances.get(root)?.();
      instances.delete(root);
    });
  });
})();
